import {lazy} from 'react';

export const DisclaimerOverlaysLazy = lazy(() => import(/* webpackChunkName: "disclaimerOverlays" */ '.'));
export const DisclaimerActionLazy = lazy(() => import(/* webpackChunkName: "disclaimerAction" */ './action'));
